"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _timesIcon = _interopRequireDefault(require("./timesIcon"));

require("./Pill.css");

function Pill(props) {
  var label = props.label,
      status = props.status,
      dismissible = props.dismissible,
      minimized = props.minimized,
      filled = props.filled,
      onClick = props.onClick,
      onDismiss = props.onDismiss,
      dismissType = props.dismissType,
      dismissText = props.dismissText,
      className = props.className,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["label", "status", "dismissible", "minimized", "filled", "onClick", "onDismiss", "dismissType", "dismissText", "className"]);
  var classNames = (0, _classnames["default"])(['stx-pill', {
    'stx-pill--with-info': status === 'info'
  }, {
    'stx-pill--with-warning': status === 'warning'
  }, {
    'stx-pill--with-success': status === 'success'
  }, {
    'stx-pill--with-alert': status === 'alert'
  }, {
    'stx-pill--is-filled': filled
  }, {
    'stx-pill--is-minimized': minimized
  }, {
    'stx-pill--is-clickable': onClick
  }, className]);

  var timesIcon = /*#__PURE__*/_react["default"].createElement("span", {
    className: "stx-pill__icon"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "stx-pill-icon__icon",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "stx-pill-icon__path",
    fill: "#6B6B6B",
    d: _timesIcon["default"]
  })));

  return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, otherProps, {
    className: classNames,
    onClick: onClick
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "stx-pill__label"
  }, label), dismissible && /*#__PURE__*/_react["default"].createElement("button", {
    className: "stx-pill__dismiss-button",
    "aria-label": dismissText,
    onClick: onDismiss
  }, dismissType === 'icon' ? timesIcon : dismissText));
}

Pill.propTypes = {
  /** Label for the pill */
  label: _propTypes["default"].string,

  /** Status modifier to change the color */
  status: _propTypes["default"].oneOf(['alert', 'warning', 'success', 'info', '']),

  /** Show the dismiss button */
  dismissible: _propTypes["default"].bool,

  /** Show the pill as a minimized indicator */
  minimized: _propTypes["default"].bool,

  /** Show the pill as a solid colour instead of an outline */
  filled: _propTypes["default"].bool,

  /** Event that fires when you click on the pill */
  onClick: _propTypes["default"].func,

  /** Event that fires when you click on the dismiss button */
  onDismiss: _propTypes["default"].func,

  /** Dismiss button type */
  dismissType: _propTypes["default"].oneOf(['string', 'icon']),

  /** Dismiss text for dismissType of string and aria label of dismiss button */
  dismissText: _propTypes["default"].string,

  /** Additional classname(s) */
  className: _propTypes["default"].string
};
var _default = Pill;
exports["default"] = _default;